module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[86]573.7a8493b.woff2";